import { render, staticRenderFns } from "./PartnerBadge.vue?vue&type=template&id=02c06714&scoped=true"
import script from "./PartnerBadge.vue?vue&type=script&lang=js"
export * from "./PartnerBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c06714",
  null
  
)

export default component.exports